import { useRef } from 'react'

interface FileUploadButtonProps {
  onFilesSelected: (files: File[]) => void
  disabled?: boolean
  className?: string
}

export function FileUploadButton({ onFilesSelected, disabled, className = 'p-2 text-[rgb(var(--np-tx-muted))] hover:text-[rgb(var(--np-tx-secondary))] hover:bg-[rgb(var(--np-raised))] rounded-lg transition-colors disabled:opacity-40' }: FileUploadButtonProps) {
  const inputRef = useRef<HTMLInputElement>(null)

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        className="hidden"
        onChange={(e) => {
          const files = Array.from(e.target.files ?? [])
          if (files.length > 0) onFilesSelected(files)
          e.target.value = ''
        }}
      />
      <button
        onClick={() => inputRef.current?.click()}
        disabled={disabled}
        className={className}
        title="Attach file"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
        </svg>
      </button>
    </>
  )
}
